import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="relative bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white py-12 md:py-16 border-t border-purple-500/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 mb-8">
          {/* Brand Section */}
          <div className="space-y-4">
            <h3 className="text-2xl font-bold bg-gradient-to-r from-purple-400 to-blue-400 bg-clip-text text-transparent">
              Market Me
            </h3>
            <p className="text-gray-400 text-sm leading-relaxed">
              Premium websites that convert visitors into customers. We design, launch, and manage high-performing websites for businesses that want real results.
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold text-white">Quick Links</h4>
            <nav className="flex flex-col space-y-2" aria-label="Footer navigation">
              <Link 
                to="/privacy-policy" 
                onClick={scrollToTop}
                className="text-gray-400 hover:text-purple-400 transition-colors duration-300 text-sm focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 focus:ring-offset-slate-900 rounded-md inline-block w-fit"
              >
                Privacy Policy
              </Link>
              <Link 
                to="/terms-conditions" 
                onClick={scrollToTop}
                className="text-gray-400 hover:text-purple-400 transition-colors duration-300 text-sm focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 focus:ring-offset-slate-900 rounded-md inline-block w-fit"
              >
                Terms &amp; Conditions
              </Link>
              <Link 
                to="/cookie-policy" 
                onClick={scrollToTop}
                className="text-gray-400 hover:text-purple-400 transition-colors duration-300 text-sm focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 focus:ring-offset-slate-900 rounded-md inline-block w-fit"
              >
                Cookie Policy
              </Link>
            </nav>
          </div>

          {/* Contact Information */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold text-white">Get In Touch</h4>
            <div className="space-y-3">
              <a 
                href="mailto:team.marketme@gmail.com" 
                className="flex items-center gap-3 text-gray-400 hover:text-purple-400 transition-colors duration-300 text-sm group focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 focus:ring-offset-slate-900 rounded-md w-fit"
                aria-label="Email us at team.marketme@gmail.com"
              >
                <div className="w-8 h-8 bg-purple-500/10 rounded-lg flex items-center justify-center group-hover:bg-purple-500/20 transition-colors duration-300">
                  <i className="ri-mail-line text-purple-400"></i>
                </div>
                <span>team.marketme@gmail.com</span>
              </a>
              
              {/* Social Media Links */}
              <div className="flex gap-3 pt-2">
                <a 
                  href="https://www.facebook.com/share/1CsPFwgTSM/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-white/5 hover:bg-purple-500/20 rounded-lg flex items-center justify-center transition-all duration-300 group focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 focus:ring-offset-slate-900"
                  aria-label="Visit our Facebook page"
                >
                  <i className="ri-facebook-fill text-gray-400 group-hover:text-purple-400 transition-colors duration-300"></i>
                </a>
                <a 
                  href="https://www.instagram.com/market_me.uk?igsh=OGVkbTFmcnNrdno0" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-white/5 hover:bg-purple-500/20 rounded-lg flex items-center justify-center transition-all duration-300 group focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 focus:ring-offset-slate-900"
                  aria-label="Visit our Instagram page"
                >
                  <i className="ri-instagram-line text-gray-400 group-hover:text-purple-400 transition-colors duration-300"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-center items-center">
            <p className="text-gray-400 text-sm text-center">
              &copy; {currentYear} Market Me. All rights reserved.
            </p>
          </div>
        </div>
      </div>

      {/* Subtle Background Gradient */}
      <div className="absolute inset-0 bg-gradient-to-t from-purple-900/5 to-transparent pointer-events-none"></div>
    </footer>
  );
}
